exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n    --main-blue: #252332;\n    --main-blue-light: rgba(37, 35, 50, 0.8);\n    --main-blue-lighter: rgba(37, 35, 50, 0.2);\n    --main-blue-lighterer: rgba(37, 35, 50, 0.1);\n    --second-blue: #7E90A6;\n    --main-red: #DC0044;\n    --main-orange: #E84743;\n    --second-red: #b9003b;\n    --pale-red: #dc9494;\n    --main-white: #FFF;\n    --main-grey: #d6d6d6;\n    --main-gradient: linear-gradient(135deg, var(--main-red) 0%, var(--second-red) 100%);\n    --bg-color: var(--second-blue);\n\n    --table-taken: #DC0044;\n    --table-available: #44AF69;\n    --table-overlap: #ECC30B;\n\n    --fonts: 'Ubuntu', sans-serif;\n\n    --stripes-bg: white repeating-linear-gradient(\n        45deg,\n        var(--main-white),\n        var(--main-white) 2.5px,\n        var(--main-blue-lighterer) 2.5px,\n        var(--main-blue-lighterer) 5px\n    );\n\n    --res-container-h: calc(100vh - 230px);\n\n    --main-grey: rgb(155, 155, 155);\n\n    --closed: #eaeaea;\n    --full: rgb(253, 139, 139);\n    --infos: rgb(116, 116, 255);\n    --available: #44AF69;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/baresthoVars.css
// module id = 1086
// module chunks = 7